export const GET_MODELS = 'GET_MODELS';// 获取机型列表

export const GET_SINGLE_PLAN = 'GET_SINGLE_PLAN';// 获取匹配的方案

export const GET_ALL_PLAN = 'GET_ALL_PLAN';// 获取所有的方案

export const UPDATE_PLAN = 'UPDATE_PLAN';// 更新机型对应的方案


